import { c as _c } from "react/compiler-runtime";
import React, { FC } from 'react';
import { ProductionGraph } from '.';
import { DateTime } from 'luxon';
import { MockGraphCover } from '@app/_components/lf-graph/MockGraphCover';
const mockActual = [{
  value: 80,
  label: 'January',
  year: DateTime.now().year,
  average_yield: 0,
  month: 1,
  day: null,
  week: null
}, {
  value: 75,
  label: 'February',
  year: DateTime.now().year,
  average_yield: 0,
  month: 2,
  day: null,
  week: null
}, {
  value: 60,
  label: 'March',
  year: DateTime.now().year,
  average_yield: 0,
  month: 3,
  day: null,
  week: null
}, {
  value: 85,
  label: 'April',
  year: DateTime.now().year,
  average_yield: 0,
  month: 4,
  day: null,
  week: null
}, {
  value: 65,
  label: 'May',
  year: DateTime.now().year,
  average_yield: 0,
  month: 5,
  day: null,
  week: null
}, {
  value: 90,
  label: 'June',
  year: DateTime.now().year,
  average_yield: 0,
  month: 6,
  day: null,
  week: null
}, {
  value: 15,
  label: 'July',
  year: DateTime.now().year,
  average_yield: 0,
  month: 7,
  day: null,
  week: null
}, {
  value: 140,
  label: 'August',
  year: DateTime.now().year,
  average_yield: 0,
  month: 8,
  day: null,
  week: null
}, {
  value: 16,
  label: 'September',
  year: DateTime.now().year,
  average_yield: 0,
  month: 9,
  day: null,
  week: null
}, {
  value: 95,
  label: 'October',
  year: DateTime.now().year,
  average_yield: 0,
  month: 10,
  day: null,
  week: null
}, {
  value: 87,
  label: 'November',
  year: DateTime.now().year,
  average_yield: 0,
  month: 11,
  day: null,
  week: null
}, {
  value: 40,
  label: 'December',
  year: DateTime.now().year,
  average_yield: 0,
  month: 12,
  day: null,
  week: null
}];
const mockPredicted = [{
  value: 85,
  label: 'January',
  year: DateTime.now().year,
  average_yield: 0,
  month: 1,
  day: null,
  week: null
}, {
  value: 72,
  label: 'February',
  year: DateTime.now().year,
  average_yield: 0,
  month: 2,
  day: null,
  week: null
}, {
  value: 64,
  label: 'March',
  year: DateTime.now().year,
  average_yield: 0,
  month: 3,
  day: null,
  week: null
}, {
  value: 95,
  label: 'April',
  year: DateTime.now().year,
  average_yield: 0,
  month: 4,
  day: null,
  week: null
}, {
  value: 75,
  label: 'May',
  year: DateTime.now().year,
  average_yield: 0,
  month: 5,
  day: null,
  week: null
}, {
  value: 91,
  label: 'June',
  year: DateTime.now().year,
  average_yield: 0,
  month: 6,
  day: null,
  week: null
}, {
  value: 55,
  label: 'July',
  year: DateTime.now().year,
  average_yield: 0,
  month: 7,
  day: null,
  week: null
}, {
  value: 100,
  label: 'August',
  year: DateTime.now().year,
  average_yield: 0,
  month: 8,
  day: null,
  week: null
}, {
  value: 80,
  label: 'September',
  year: DateTime.now().year,
  average_yield: 0,
  month: 9,
  day: null,
  week: null
}, {
  value: 90,
  label: 'October',
  year: DateTime.now().year,
  average_yield: 0,
  month: 10,
  day: null,
  week: null
}, {
  value: 84,
  label: 'November',
  year: DateTime.now().year,
  average_yield: 0,
  month: 11,
  day: null,
  week: null
}, {
  value: 72,
  label: 'December',
  year: DateTime.now().year,
  average_yield: 0,
  month: 12,
  day: null,
  week: null
}];
export const MockProductionGraph: FC<{
  title: string;
}> = t0 => {
  const $ = _c(3);
  const {
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ProductionGraph actual={{
      total: mockActual.reduce(_temp, 0),
      average: 0,
      averageYield: 0,
      percentageOfTarget: 0,
      percentageOfTargetYield: 0,
      targetYield: 0,
      values: mockActual
    }} predicted={{
      total: mockPredicted.reduce(_temp2, 0),
      values: mockPredicted
    }} targetMax={100} targetMin={75} mock={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <MockGraphCover coverText={title}>{t1}</MockGraphCover>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(acc, curr) {
  acc = acc + curr.value;
  return acc;
}
function _temp2(acc_0, curr_0) {
  acc_0 = acc_0 + curr_0.value;
  return acc_0;
}